import { render, staticRenderFns } from "./mod6.vue?vue&type=template&id=0fd55628&scoped=true&"
import script from "./mod6.vue?vue&type=script&lang=js&"
export * from "./mod6.vue?vue&type=script&lang=js&"
import style0 from "./mod6.vue?vue&type=style&index=0&id=0fd55628&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd55628",
  null
  
)

export default component.exports